<template>
	<div class="row">
		<div class="col">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<label for="user">{{'User' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.user" id="user">
						<form-errors :field-name="'user'" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label for="pass">{{'Password' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.pass" id="pass">
						<form-errors :field-name="'pass'" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<label for="lang">{{'Lang' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.lang" id="lang">
						<form-errors :field-name="'lang'" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label for="client_id">{{'Client ID' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.client_id" id="client_id">
						<form-errors :field-name="'client_id'" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<label for="role_id">{{'Role ID' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.role_id" id="role_id">
						<form-errors :field-name="'role_id'" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label for="org_id">{{'Org ID' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.org_id" id="org_id">
						<form-errors :field-name="'org_id'" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<label for="warehouse_id">{{'Warehouse ID' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.warehouse_id" id="warehouse_id">
						<form-errors :field-name="'warehouse_id'" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label for="stage">{{'Stage' | trans}}</label>
						<input type="text" class="form-control" v-model="adLogin.stage" id="stage">
						<form-errors :field-name="'stage'" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label for="description">{{'Description' | trans}}</label>
						<textarea type="text" class="form-control" v-model="adLogin.description" id="description">
						</textarea>
						<form-errors :field-name="'description'" />
					</div>
				</div>
			</div>
			<div class="form-check mb-5" v-if="adLogin.id">
				<input type="checkbox" class="form-check-input" id="default" v-model="adLogin.default">
				<label class="form-check-label" for="default">{{'Default' | trans}}</label>
			</div>
			<div class="form-group">
				<spinner-button :className="'btn btn-info'" @click="submit($event)" :is-pending="isPending">
					{{'Complete' | trans}}
				</spinner-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ad-login",
		props: ['route', 'editRoute', 'updateRoute'],
		data() {
			return {
				adLogin: {},
				isPending: false,
			};
		},
		mounted() {
			this.EventBus.$on('resetAdLoginForm', () => {

			});
			this.EventBus.$on('fillAdLoginForm', () => {
				this.adLogin.id = this.$root.currentAdLoginID;
				this.load();
			});
		},
		methods: {
			async submit(event) {
				event.stopPropagation();
				event.preventDefault();
				this.isPending = true;
				this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
				let route = (this.adLogin.id)? this.updateRoute+'/'+this.adLogin.id: this.route;
				await axios.post(route, this.adLogin)
					.then(() => {
						this.EventBus.$emit('event-success', Lang.get('Success'));
						setTimeout(() => window.location.reload(), 1000);
					})
					.finally(() => this.isPending = false);
			},
			async load() {
				this.isPending = true;
				this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
				let result = await axios.post(this.editRoute+'/'+this.adLogin.id)
					.finally(() => this.isPending = false);
				this.adLogin = result.data;
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ad-login.vue